import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useDebounce } from "use-debounce";
import ErrorMessage from "../common/ErrorMessage";
import { POST } from "../../utils/HttpClient";
import * as _ from "lodash";
import { QrReader } from 'react-qr-reader';
import Title from "antd/es/typography/Title";
import { Form, Input, Modal, Row } from "antd";
import ColorButton from "../common/ColorButton";
import { QrcodeOutlined, LoadingOutlined } from "@ant-design/icons";
import { BLUE_COLOR } from "../../constance/color";


const DEFAULT_ON_SUBMIT_LENGTH = 14;

const BarcodeInput = React.forwardRef((props, ref) => {
  const {
    submitUrl,
    onNext,
  } = props;

  const [form] = Form.useForm();
  const { t } = useTranslation();
  const inputRef = React.useRef();
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const barcodeInput = Form.useWatch('qrCode', form) || '';
  const [barcodeSearch] = useDebounce(barcodeInput, 500);
  const [scanModal, setScanModal] = React.useState(false);


  const handleSubmit = async (barcode) => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const response = await POST(submitUrl, { barcode });
      onNext(_.get(response, 'data.id', ''));
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  }

  const handleOpenQRCode = () => {
    if (window.JSInterface) {
      // if open in ww factory then use interface
      window.JSInterface.scanBarcode();
      if (inputRef.current) {
        inputRef.current.focus();
      }
    } else {
      // if https then go normal library scan qr
      setScanModal(true);
    }
  }

  const onBarcodeScanned = (values) => {
    // for handling android function called
    form.setFieldValue('qrCode', values)
  }

  React.useEffect(() => {
    if (barcodeSearch.length == DEFAULT_ON_SUBMIT_LENGTH) {
      handleSubmit(barcodeSearch);
    }
  }, [barcodeSearch])

  React.useEffect(() => {
    window.onBarcodeScanned = (values) => {
      onBarcodeScanned(values)
    }

    return () => {
      window.onBarcodeScanned = () => null
    }
  }, [])

  return (
    <div style={{ marginTop: '6rem' }}>
      <ErrorMessage message={errorMessages} />
      <Title level={5}>{t('barcodes.barcode_input')}</Title>
      <Form form={form}>
        <Row justify='center'>
          <Form.Item name={'qrCode'}>
            <Input ref={inputRef} loading={loading} disabled={loading} suffix={loading ? <LoadingOutlined /> : null} />
          </Form.Item>
        </Row>
        <ColorButton
          type="primary" override={BLUE_COLOR}
          icon={<QrcodeOutlined />} size='large'
          onClick={() => handleOpenQRCode(form.getFieldsValue())} >{t('scan')}</ColorButton>
      </Form>

      <Modal
        open={scanModal} onCancel={() => { setScanModal(false) }}
        title={<span><QrcodeOutlined />{t('barcodes.barcode_input')}</span>}
        footer={null} destroyOnClose={true}>
        {scanModal && (
          <QrReader
            constraints={{ facingMode: "environment" }}
            onResult={(result, e) => {
              if (result) {
                form.setFieldValue('qrCode', _.get(result, 'text', ''))
                setScanModal(false);
              }
            }}
            style={{ width: '100%' }} />)}
      </Modal>
    </div>
  )
})

export default BarcodeInput;

BarcodeInput.propTypes = {
  submitUrl: PropTypes.string,
  onNext: PropTypes.func,
}

BarcodeInput.defaultProps = {
  submitUrl: '',
  onNext: () => null,
}